import promotion from '@resources/js/components/promotion'
import { getBcomOrExpediaPartnerType } from '@resources/js/components/promotion/helpers/getPartnerType'
import BcomSearchForm from '@resources/js/components/BcomSearchForm';
import '@resources/js/analytics'

const partnerType = getBcomOrExpediaPartnerType()

promotion({
    links: {
        active: !!shared.options.dest_id,
        type: partnerType
    },
    backbtn: {
        active: !!shared.options.bbcl && !!shared.options.dest_id,
        type: partnerType
    },
    tab_change: {
        active: !!shared.options.dest_id,
        type: partnerType
    },
    popup: {
        active: !!shared.options.dest_id,
        type: partnerType
    }
})

if (document.querySelector('#search-form'))
    new BcomSearchForm('#search-form')
